export const loginPage = {
    backupTimeoutSec: ['Интервал резервирования (сек)', 'Backup data timeout (sec)'],
    confirmationCode: ['Код подтверждения', 'Confirmation code'],
    login: ['Логин', 'Login'],
    loginButton: ['Войти', 'Login'],
    loginSuccess: ['Успешный вход в систему', 'Login is successful'],
    loginSuccessError: ['Успешный вход в систему, но произошла ошибка', 'Login success, but error occurred'],
    loginSuccessErrorMes: ['Успешный вход в систему, но {{error}}', 'Login success, but {{error}}'],
    password: ['Пароль', 'Password'],
    refreshCode: ['Обновить код', 'Refresh code'],
    restore: ['Восстановить', 'Restore'],
    serverName: ['Имя сервера', 'Server name'],
    ssl: ['SSL', 'SSL'],
    willSendConfirmationCode: ['Код подтверждения будет отправлен на:', 'We will send the confirmation code to:'],

    validation: {
        emptyLogin: ['Требуются логин и пароль', 'Login and Password are required'],
    },
};
